import React, { useMemo } from 'react';
import './student-onboarding-fall-2023.css'
import SearchHeader from '../SearchHeader/SearchHeader';
import { FilterTypeId } from '../SearchHeader/filters-type';
import axios from 'axios';
import _ from "lodash";
import { baseUrl } from '../assets/Animations';
import {BsThreeDotsVertical} from 'react-icons/bs'
import { FinishedLady } from './assets/FinishedLady';
import { getRequestHeaders } from '../api';
import StudentOnboardingTaskCard2023 from './StudentOnboardingTaskCard2023/StudentOnboardingTaskCard2023';
import ConfettiZoneStudentOnboarding from './ConfettiZoneStudentOnboarding';
import ModalDropdownMenuFall2023 from '../StudentOnboardingCardModalFall2023/ModalAreaFall2023/ModalDropdownMenuFall2023/ModalDropdownMenuFall2023';
import ManuallyAddStudentPopup from './ManuallyAddStudentPopup/ManuallyAddStudentPopup';
import { isWithinInterval, subWeeks } from 'date-fns';
import { createChatGptPrompt } from './chatgptpromptfunctions';


const StudentOnboardingFall2023 = ({
        setStudentOnboardingModal, 
        getStudentOnboardingCards, 
        rawStudentOnboardingCards,
        setRawStudentOnboardingCards,
        waitlistEntities, 
        setWaitlistEntities,
        rawWaitlistFamilies, 
        setRawWaitlistFamilies,
        studentOnboardingCards, 
        setStudentOnboardingCards,
        isConfettiExplosion,
        setIsConfettiExplosion,
        socket,
        userData,
        studentOnboardingCardsInUse,
        setStudentOnboardingCardsInUse
    }) => {

    const [schools, setSchools] = React.useState([]);
    //const [calendarEvents, setCalendarEvents] = React.useState([]);
    const [filterState, setFilterState] = React.useState({school: 'all'});
    const [openDropdown, setOpenDropdown] = React.useState(false);
    const [manuallyAddStudentPopup, setManuallyAddStudentPopup] = React.useState(false);
    const [labels, setLabels] = React.useState({});
    const [displayWaitlist, setDisplayWaitlist] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [showSchoolsOnCards, setShowSchoolsOnCards] = React.useState(true);
    const [toolTip, setToolTip] = React.useState(false);
    const [teachers, setTeachers] = React.useState([]);
    const [students, setStudents] = React.useState([]);
    const [needsNewTeacherFamilies, setNeedsNewTeacherFamilies] = React.useState([]);
    const [nameQuery, setNameQuery] = React.useState("");
    const [filteredCards, setFilteredCards] = React.useState([]);


    const getWaitlistStudents = () => axios.get(`${baseUrl}/waitlist`, getRequestHeaders())
    const getWaitlistEntities = () => axios.get(`${baseUrl}/waitlists`, getRequestHeaders())
    //const getCalendar = () => axios.get(`${baseUrl}/calendar`, getRequestHeaders())
    //const getSchools = () => axios.get(`${baseUrl}/schools`)
    const getStudents = () => axios.get(`${baseUrl}/engaged-students`, getRequestHeaders())

    const onboardingColumns = [
        {
            title: 'TEACHER LEAVING',
            filterName: 'leaving',
            dropDownMenuOptions: [
                {
                    label: displayWaitlist ? 'Hide' : 'Show',
                    onClick: () => setDisplayWaitlist(!displayWaitlist)
                },
                // {
                //     label: 'Copy ChatGTP Prompt',
                //     onClick: () => createChatGptPrompt(students, teachers)
                // },
            ],
            total: true
        },
        // {
        //     title: 'WAITLIST',
        //     filterName: 'waitlist',
        //     dropDownMenuOptions: [
        //         {
        //             label: displayWaitlist ? 'Hide' : 'Show',
        //             onClick: () => setDisplayWaitlist(!displayWaitlist)
        //         },
        //     ],
        //     total: true
        // },
        // {
        //     title: 'INQUIRIES',
        //     filterName: 'inquiry',
        //     dropDownMenuOptions: [
        //         {
        //             label: '+ New Student (Default)',
        //             onClick: () => setManuallyAddStudentPopup(['New Student', 'inquiry'])
        //         },
        //         {
        //             label: '+ Reassign',
        //             onClick: () => setManuallyAddStudentPopup(['Reassign', 'inquiry'])
        //         },
        //         {
        //             label: '+ Old Student',
        //             onClick: () => setManuallyAddStudentPopup(['Old Student', 'inquiry'])
        //         }
        //     ],
        //     total: false
        // },
        {
            title: 'SCHEDULING',
            filterName: 'scheduling',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'scheduling'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'scheduling'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'scheduling'])
                }
            ],
            total: true
        },
        {
            title: 'INTRO LESSON',
            filterName: 'intro',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'intro'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'intro'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'intro'])
                }
            ],
            total: true
        },
        {
            title: 'ONBOARDING',
            filterName: 'onboarding',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'onboarding'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'onboarding'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'onboarding'])
                }
            ],
            total: true
        },
        {
            title: 'OFFBOARDING',
            filterName: 'offboard',
            dropDownMenuOptions: [
                {
                    label: '+ New Student (Default)',
                    onClick: () => setManuallyAddStudentPopup(['New Student', 'offboard'])
                },
                {
                    label: '+ Reassign',
                    onClick: () => setManuallyAddStudentPopup(['Reassign', 'offboard'])
                },
                {
                    label: '+ Old Student',
                    onClick: () => setManuallyAddStudentPopup(['Old Student', 'offboard'])
                }
            ],
            total: true
        }
    ]

    React.useEffect(() => {
        makeCalls();
        userData.PermissionLevel === 'manager' && setFilterState({school: userData.School.toLowerCase()})
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                clickBackOnCalls()
            }
          };
      
          // Add the event listener to the document
          document.addEventListener('visibilitychange', handleVisibilityChange);
      
          // Clean up the event listener when the component unmounts
          return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
          };
    }, [])

    React.useEffect(() => {
        setOpenDropdown(false)
    },[displayWaitlist])

    React.useEffect(() => {
        highlightAlreadyInUseCards()
    }, [studentOnboardingCardsInUse])

    React.useEffect(() => {
        socket.on('createStudentWorkflow', (packet) => {
            if(packet.emitter !== userData.Name) {
                setRawStudentOnboardingCards(prev => [...prev, packet.data])
                //setRawWaitlistFamilies(prev => prev.filter((family) => family.familyId !== packet.data.familyId && family))
            }
            moveCardAnimation(packet.data.todoId)

        })
        socket.on('openStudentWorkflow', (packet) => {
            if(packet.emitter !== userData.Name) {
                setLabels(prev => ({...prev, [packet.data]: packet.emitter}))
            }
        })
        socket.on('closeAndSaveStudentWorkflow', (packet) => {
            if(packet.updatedCard.emitter !== userData.Name) {
                //remove the todoId key value pair from labels
                let labelsCopy = labels;
                delete labelsCopy[packet.updatedCard.data.todoId]
                setLabels({...labelsCopy})
                setRawStudentOnboardingCards(prev => prev.map(flow => flow.todoId === packet.updatedCard.data.todoId ? packet.updatedCard.data : flow))
                setStudentOnboardingCardsInUse(prev => prev.filter(card => card.data !== packet.updatedCard.data.todoId))
            }
            moveCardAnimation(packet.updatedCard.data.todoId)
        })
        socket.on('closeAndDeleteStudentWorkflow', async (packet) => {
            if(packet.emitter !== userData.Name) {
                let labelsCopy = labels;
                delete labelsCopy[packet.data]
                setLabels({...labelsCopy})
                setRawStudentOnboardingCards(prev => prev.filter(flow => flow.todoId !== packet.data))
                //let waitListFamiliesRefresh = await getWaitlistStudents();
                //setRawWaitlistFamilies(waitListFamiliesRefresh.data)
            }
        })
    }, [socket])



    const findAllStudentsOfLeavingAndLeftTeachers = () => {
        const leavingTeacherIDs = new Set(
            teachers
                .filter((teacher) => teacher.Status === 'leaving' || teacher.Status === 'Left School' || teacher.Status === 'summer-break')
                .map((teacher) => teacher.TeacherID)
        );
    
        // Step 2: Filter families where any student has a teacher who is leaving and is active
        const studentsOfLeavingTeachers = students.filter((family) =>
            family.students.some((student) =>
                leavingTeacherIDs.has(student.teachersId) && student.studentStatus === 'Active'
            )
            ||
            family.students.some((student) =>
                student.studentStatus === 'Summer Break' || family.familyStatus === 'Needs New Teacher'
            )
            ||
            family.familyStatus === 'Summer Break' || family.familyStatus === 'Needs New Teacher'
        );

        // Step 3: Update state and return results
        setNeedsNewTeacherFamilies(studentsOfLeavingTeachers);
        return studentsOfLeavingTeachers;
    };

    React.useEffect(() => {
        if(students.length > 0 && teachers.length > 0) {
            setRawWaitlistFamilies(findAllStudentsOfLeavingAndLeftTeachers())
        }
    }, [students, teachers, rawStudentOnboardingCards])


    const filterCards = React.useCallback(() => {
            const masterList = studentOnboardingCards.filter((card) => {
              // Name
              const teachName = card.todoName.toString().toLocaleLowerCase();
              const nameFilter = nameQuery.toString().toLocaleLowerCase();
              const nameMatch = !nameFilter || teachName.includes(nameFilter);
              // Schools
              const selectedSchools = (filterState.school === 'all' || !filterState.school) ? null : filterState.school;
              const schoolMatch =
                !selectedSchools ||
                selectedSchools.length === 0 ||
                selectedSchools.includes(card.whichSchool);
              // Instruments
              const selectedInstruments = filterState.instrument;
              const instrumentMatch =
              !selectedInstruments ||
              selectedInstruments.length === 0 ||
              card.studentList.some((student) =>
                student.instrumentList.some((instrument) =>
                  selectedInstruments.includes(instrument.id)
                )
              );
             return nameMatch && instrumentMatch && schoolMatch;
            });
            setFilteredCards(masterList);
            return filterCards;
    }, [filterState, nameQuery, studentOnboardingCards]);

    React.useEffect(() => {
        filterCards()
        userData.PermissionLevel === 'manager' && setFilterState({school: userData.School.toLowerCase()})
        if(filterState.school === 'all' || !filterState.school) {
            setShowSchoolsOnCards(true)
        } else {
            setShowSchoolsOnCards(false)
        }
    }, [filterState, nameQuery, filterCards, userData.PermissionLevel, userData.School])

    React.useEffect(() =>
          isConfettiExplosion &&
          setTimeout(() => {
            setIsConfettiExplosion(false);
          }, 5000)
    , [isConfettiExplosion]);

    const moveCardAnimation = (id) => {
        setTimeout(() => {
            if(!document.getElementById(id)) {return}
            document.getElementById(id).style.animation = 'cardMoveAttentionFlash 500ms'
            document.getElementById(id).style.animationTimingFunction = 'ease'
            document.getElementById(id).style.border = '1px solid orange'
            setTimeout(() => {
                document.getElementById(id).style.border = '1px solid #fff'
            }, 1000);
        }, 0)
    }



    const makeCalls = async () => {
        try {
            // Run API calls in parallel
            const [
                waitlistEntitiesReturn,
                studentsReturn,
                initialAdminRequestReturn,
                justAPlaceholder
            ] = await Promise.all([
                getWaitlistEntities(),
                getStudents(),
                axios.get(`${baseUrl}/initialadminrequest`, getRequestHeaders()),
                getStudentOnboardingCards()

            ]);
    
            // Set state with the returned data
            setStudents(studentsReturn.data);
            setTeachers(initialAdminRequestReturn.data);
            setWaitlistEntities(waitlistEntitiesReturn.data);

    
            let tempOrderedSchools = [
                { id: 'all', label: 'All Schools' },
                { id: 'mma', label: 'Mountainside' },
                { id: 'lsma', label: 'Lakeside' },
                { id: 'tma', label: 'Treeside' },
                { id: 'mor', label: 'Morningside' },
                { id: 'psma', label: 'Parkside' },
                { id: 'den', label: 'Denton' },
                { id: 'tem', label: 'Tempe' },
                { id: 'tul', label: 'Tulsa' }
            ];
            setSchools(tempOrderedSchools);
    
            // Call remaining functions
            //getStudentOnboardingCards();
        } catch (error) {
            console.log(error);
        }
    };


    const clickBackOnCalls = async () => {
        //const waitlistEntitiesReturn = await getWaitlistEntities();
        //const rawWaitlistFamiliesReturn = await getWaitlistStudents();
        getStudentOnboardingCards();
        if(teachers.length > 0 && students.length > 0) {
            setRawWaitlistFamilies(findAllStudentsOfLeavingAndLeftTeachers())
        }
        //setWaitlistEntities(waitlistEntitiesReturn.data);
        //setRawWaitlistFamilies(rawWaitlistFamiliesReturn.data);
    }

    const findTeachersLeavingDate = React.useCallback((family) => {
        let teacherLeavingDate = null;
        for(let i = 0; i < teachers.length; i++) {
            if(family.students.length > 0) {
                for(let j = 0; j < family.students.length; j++) {
                    if(teachers[i].TeacherID === family.students[j].teachersId) {
                        teacherLeavingDate = teachers[i].DepartureDate
                    }
                }
            } else {
                return null
            }

        }
        return teacherLeavingDate;
    }, [teachers])

    const findIfFamilyOrTeacherIsSummerBreak = React.useCallback((family) => {
        let summerBreak = false;
        for(let i = 0; i < teachers.length; i++) {
            if(family.students.length > 0) {
                for(let j = 0; j < family.students.length; j++) {
                    if(teachers[i].TeacherID === family.students[j].teachersId) {
                        if(teachers[i].Status === 'summer-break') {
                            summerBreak = true
                        }
                    }
                }
            }
        }
        if(family.familyStatus === 'Summer Break') {
            summerBreak = true
        }
        return summerBreak;
    }, [teachers])

    const findIfFamilyNeedsNewTeacher = React.useCallback((family) => {
        let needsNewTeacher = false;
        for(let i = 0; i < family.students.length; i++) {
            if(family.students[i].studentStatus === 'Needs New Teacher') {
                needsNewTeacher = true
            }
        }
        if(family.familyStatus === 'Needs New Teacher') {
            needsNewTeacher = true
        }
        return needsNewTeacher;
    }, [])

    const returnImageNameOfLeavingTeacher = React.useCallback((family) => {
        let teacherImage = null;
        for(let i = 0; i < teachers.length; i++) {
            for(let j = 0; j < family.students.length; j++) {
                if(teachers[i].TeacherID === family.students[j].teachersId) {
                    teacherImage = teachers[i].ImageName
                }
            }
        }
        return `https://app.atharo.app/images/${teacherImage}`;
    }, [teachers])

    const formatFamilyIntoCardForLeavingTeacher = React.useCallback((family) => {
        let card = {
            todoId: family.familyId,
            todoName: family.familyName,
            //todoName: family.familyStatus === 'Waitlist' ? `${family.familyName}` : findWaitlistStudentandReturnName(family),
            todoDescription: '',
            familyId: family.familyId,
            studentList: family.students,
            todoDueDate: new Date(),
            todoAlarm: false,
            theyHaveBeenCalled: false,
            todoOwner: '',
            //waitlistEntity: assessTheFamiliesWaitlistStatus(family),
            //waitlistEntity: findTeachersLeavingDate(family),
            waitlistEntity: null,
            whoIsOnWaitlist: family.familyStatus === 'Waitlist' ? 'Family' : 'Student',
            whichList: 'leaving',
            whichSchool: family.school.toLowerCase(),
            todoSubtasks: [],
            leavingTeacherImage: returnImageNameOfLeavingTeacher(family),
            leavingDate: findTeachersLeavingDate(family),
            summerBreak: findIfFamilyOrTeacherIsSummerBreak(family),
            needsNewTeacher: findIfFamilyNeedsNewTeacher(family),
        }
        return card
    }, [findTeachersLeavingDate, returnImageNameOfLeavingTeacher, findIfFamilyOrTeacherIsSummerBreak, findIfFamilyNeedsNewTeacher])

    React.useEffect(() => {
        for(let i = 0; i < rawStudentOnboardingCards.length; i++) {
            if(rawStudentOnboardingCards[i].todoName === 'Jamison') {
                console.log(rawStudentOnboardingCards[i])
            }
        }
        // Check if there are entries in both waitlist families and onboarding cards before proceeding
        if (rawWaitlistFamilies.length > 0 && rawStudentOnboardingCards.length > 0) {
            let freshListOfCards = [...rawStudentOnboardingCards];
            const formattedWaitlistCards = rawWaitlistFamilies.map((family) => formatFamilyIntoCardForLeavingTeacher(family));
            const uniqueWaitlistCards = formattedWaitlistCards.filter((waitlistCard) =>
                !freshListOfCards.some(
                    (onboardingCard) =>
                        waitlistCard?.familyId && onboardingCard?.familyId && onboardingCard.familyId === waitlistCard.familyId
                )
            );
            setStudentOnboardingCards([...freshListOfCards, ...uniqueWaitlistCards]);
            setLoading(false);
        }
    }, [rawWaitlistFamilies, rawStudentOnboardingCards, formatFamilyIntoCardForLeavingTeacher, setStudentOnboardingCards]);

    const checkIfEmailTaskIsDone = (card) => {
        if(card.todoSubtasks) {
            for(let i = 0; i < card.todoSubtasks.length; i++) {
                if(card.todoSubtasks[i].subtaskName.split(' ')[0] === 'Email' && card.todoSubtasks[i].subtaskCompleted) {
                    return true
                }
            }
        }
        return false
    }

    // const checkIfIntroLessonHasHappened = (card) => {
    //     if(card.hasIntroHappened) {return card}
    //     //if the card is in the onboarding column
    //     if(card.whichList === 'onboarding') {
    //     //if the card has a familyId
    //         if(card.familyId) {
    //             for(let i = 0; i < calendarEvents.length; i++) {
    //                 let event = calendarEvents[i]
    //                 if(event.familyId === card.familyId) {
    //                     if(!event.isPendingOffer) {
    //                         const dateIsWithinInterval = isWithinInterval(new Date(event.dateTime),{ start: subWeeks(new Date(), 1), end: new Date() })
    //                         if(dateIsWithinInterval && checkIfEmailTaskIsDone(card)) {
    //                             card.hasIntroHappened = false
    //                             return card
    //                         } else if (dateIsWithinInterval && !checkIfEmailTaskIsDone(card)) {
    //                             card.hasIntroHappened = 'follow-up'
    //                             return card
    //                         }
    //                     }
    //             }
    //         }
    //         }
    //         card.hasIntroHappened = false
    //         return card
    //     }
    // }

    const findCardsBySchoolAndList = (list) => {
        let cards = [];
        filteredCards.forEach((card) => {
            //don't show the waitlist cards if the user has selected to hide them
            if(displayWaitlist === false && card.whichList === 'waitlist') {
                return
            }
            if((filterState.school === 'all' || !filterState.school) && card.whichList === list) {
                //checkIfIntroLessonHasHappened(card)
                cards.push(card)
            } else {
                (card.whichSchool.toLowerCase() === filterState.school && card.whichList === list) && cards.push(card);
                if(card.whichSchool.toLowerCase() === filterState.school && card.whichList === 'student' && list === 'scheduling') {
                    //checkIfIntroLessonHasHappened(card)
                    cards.push(card)
                }
            }
        })
            //sort cards by todoDueDate
            if(list === 'intro') {
                cards.sort((a, b) => new Date(a.todoDueDate) - new Date(b.todoDueDate))
            } else if (list === 'leaving') {
                cards.sort((a, b) => new Date(b.leavingDate) - new Date(a.leavingDate))
            } else {
                cards.sort((a, b) => new Date(b.todoDueDate) - new Date(a.todoDueDate))
            }

        //move cards that hasIntroHappened to the top of the array
        // let cardsWithIntroHappened = [];
        // let cardsWithoutIntroHappened = [];
        // cards.forEach((card) => {
        //     if(card.hasIntroHappened) {
        //         cardsWithIntroHappened.push(card)
        //     } else {
        //         cardsWithoutIntroHappened.push(card)
        //     }
        // })
        // cards = [...cardsWithIntroHappened, ...cardsWithoutIntroHappened]
        return cards;
    }

    const checkForWaitlistEntitiesForFamily = (infoArray) => {
        let returnEntity = null
        waitlistEntities.forEach((entity) => {
            if(entity.entity === infoArray[0]) {
                if(infoArray[0] === 'Family' && entity.entityId === infoArray[1]) {
                    returnEntity = entity;
                } else if (infoArray[0] === 'Student' && entity.entityId === infoArray[1]) {
                    returnEntity = entity;
                }
            }
        })
        return returnEntity;
    }

    // const formatFamilyIntoCardForWaitlist = (family) => {
    //     let card = {
    //         todoId: family.familyId,
    //         todoName: family.familyStatus === 'Waitlist' ? `${family.familyName}` : findWaitlistStudentandReturnName(family),
    //         todoDescription: '',
    //         familyId: family.familyId,
    //         studentList: family.students,
    //         todoDueDate: new Date(),
    //         todoAlarm: false,
    //         theyHaveBeenCalled: false,
    //         todoOwner: '',
    //         waitlistEntity: assessTheFamiliesWaitlistStatus(family),
    //         whoIsOnWaitlist: family.familyStatus === 'Waitlist' ? 'Family' : 'Student',
    //         whichList: 'waitlist',
    //         whichSchool: family.school.toLowerCase(),
    //         todoSubtasks: []
    //       }
    //       return card
    // }

    // const assessTheFamiliesWaitlistStatus = (family) => {
    //     let listOfWaitlistLabelAndIdPairs = [];
    //     let listOfWaitlistEntities = [];
    //     //Find if family is on waitlist and if the students are on the waitlist
    //     if(family.familyStatus === 'Waitlist') {
    //         listOfWaitlistLabelAndIdPairs.push(['Family', family.familyId])
    //         for(let i = 0; i < family.students.length; i++) {
    //             if(family.students[i].studentStatus === 'Waitlist') {
    //                 listOfWaitlistLabelAndIdPairs.push(['Student', family.students[i].studentId])
    //             }
    //         }
    //     } else {
    //         for(let i = 0; i < family.students.length; i++) {
    //             if(family.students[i].studentStatus === 'Waitlist') {
    //                 listOfWaitlistLabelAndIdPairs.push(['Student', family.students[i].studentId])
    //             }
    //         }
    //     }
    //     //get all the waitlist entities
    //     listOfWaitlistLabelAndIdPairs.forEach((pair) => {
    //         let entity = checkForWaitlistEntitiesForFamily(pair)
    //         entity && listOfWaitlistEntities.push(entity)
    //     })
    //     //find the oldest waitlist entity in the array
    //     let oldestWaitlistEntity = listOfWaitlistEntities[0];
    //     for(let i = 1; i < listOfWaitlistEntities.length; i++) {
    //         if(listOfWaitlistEntities[i].startDate < oldestWaitlistEntity.startDate) {
    //             oldestWaitlistEntity = listOfWaitlistEntities[i];
    //         }
    //     }
    //     return oldestWaitlistEntity ? oldestWaitlistEntity : null;
    // }

    const findWaitlistStudentandReturnName = (family) => {
        for(let i = 0; i < family.students.length; i++) {
            let studentName = family.students[i].studentName
            if(family.students[i].studentStatus === 'Waitlist') {
                if(studentName.split(' ')[1] === family.familyName) {
                    return `${studentName.split(' ')[0]} ${family.familyName}`
                } else {
                    return `${studentName} ${family.familyName}`
                }
            }
        }
    }

    const highlightAlreadyInUseCards = () => {
        for(let i = 0; i < studentOnboardingCards.length; i++) {
            if(document.getElementById(studentOnboardingCards[i].todoId)) {
                document.getElementById(studentOnboardingCards[i].todoId).style.border = "none"
                document.getElementById(`user-${studentOnboardingCards[i].todoId}`).style.display = 'none'
            }
        }
        for(let i = 0; i < rawStudentOnboardingCards.length; i++) {
            if(document.getElementById(rawStudentOnboardingCards[i].todoId)) {
                document.getElementById(rawStudentOnboardingCards[i].todoId).style.border = "none"
                document.getElementById(`user-${rawStudentOnboardingCards[i].todoId}`).style.display = 'none'
            }
        }
        for(let i = 0; i < studentOnboardingCardsInUse.length; i++) {
            if(document.getElementById(studentOnboardingCardsInUse[i].data)) {
                document.getElementById(studentOnboardingCardsInUse[i].data).style.border = "2px solid fuchsia"
                document.getElementById(`user-${studentOnboardingCardsInUse[i].data}`).style.padding = '2px'
                document.getElementById(`user-${studentOnboardingCardsInUse[i].data}`).style.display = 'inline-block'
            }
        }
    }

    const createASpecificCardForASpecificFamily = (familyId, column, typeOfCard, callback) => {
        axios.post(`${baseUrl}/create-student-onboarding-card/${familyId}/${column}/${typeOfCard}`, getRequestHeaders())
        .then((res) => {
            //Add the card to the studentOnboardingCards array
            setStudentOnboardingCards(prev => ([...prev, res.data]))
            setRawStudentOnboardingCards(prev => ([...prev, res.data]))
            callback(false)
        })
        .catch((err) => console.log(err))
    }


    const filters = useMemo(() => [
        {
            id: "instrument",
            label: "Instrument",
            type: FilterTypeId.Dropdown,
            options:
              teachers &&
              _.uniqBy(
                teachers.reduce((acc, teacher) => {
                  return [
                    ...acc,
                    ...teacher.InstrumentList.map((instrument) => {
                      return {
                        id: instrument.id,
                        label: instrument.name,
                        group: instrument.instrumentGroup,
                      };
                    }),
                  ];
                }, []),
                (x) => x.id
              ),
          },
        userData.PermissionLevel !== 'manager' && {
            id: "school",
            label: "School",
            type: FilterTypeId.SelectDropDown,
            options: schools ? schools : [],
          },
        ], [schools, teachers, userData.PermissionLevel]);

    const openStudentOnboardingCard = (card) => {
        socket.emit('openStudentWorkflow', {emitter: userData.Name, data:card.todoId})
        setStudentOnboardingModal(card)
    }

    const calculateTotal = (list) => {
        let total = 0;
        findCardsBySchoolAndList(list).forEach((card) => {
            if(card.whichList === list) {
                total = total + card.studentList.length
            }
        })

        return total > 0 ? `(${total})` : null;
    }

    return (
        <div className='student-onboarding-fall-2023__wrapper'>
            {manuallyAddStudentPopup && <ManuallyAddStudentPopup manuallyAddStudentPopup={manuallyAddStudentPopup} setManuallyAddStudentPopup={setManuallyAddStudentPopup} createASpecificCardForASpecificFamily={createASpecificCardForASpecificFamily} />}
            {/* {toolTip && <OnboardingToolTip2023 card={toolTip} calendarEvents={calendarEvents} />} */}
            <ConfettiZoneStudentOnboarding isConfettiExplosion={isConfettiExplosion} />
            <SearchHeader title= "Student Onboarding" filters={filters} onChangeQuery={(string) => setNameQuery(string)} onChangeFilters={(filterState) => setFilterState(filterState)} clearAll={true} />
            <div className='student-onboarding-fall-2023__columns-wrapper'>
                {onboardingColumns.map((column, index) => 
                    <div key={index} className='student-onboarding-fall-2023__column'>
                        <div className='student-onboarding-fall-2023__column-title__area'>
                            <div className='student-onboarding-fall-2023__column-title'>{column.title} {column.total ? calculateTotal(column.filterName) : null}</div>
                            <BsThreeDotsVertical cursor={'pointer'} color='#94A3B8' onClick={() => setOpenDropdown(column.title)} />
                            {openDropdown === column.title && <ModalDropdownMenuFall2023 menuItems={column.dropDownMenuOptions} setOpenDropdown={setOpenDropdown} />}
                        </div>
                        {
                            loading && findCardsBySchoolAndList(column.filterName).length === 0 ? 
                            <div className='student-onboarding-fall-2023__loading'>LOADING...</div>  
                        :
                            <div className='student-onboarding-fall-2023__column-scroll-area' style={findCardsBySchoolAndList(column.filterName).length === 0 ? {backgroundColor: '#F1F5F9'} : {backgroundColor: 'rgb(248, 250, 252)'}}>
                            {findCardsBySchoolAndList(column.filterName).length > 0 ?
                                <div>
                                    {findCardsBySchoolAndList(column.filterName).map((card) => <StudentOnboardingTaskCard2023 key={card.todoId} labels={labels} card={card} showSchoolsOnCards={showSchoolsOnCards} setStudentOnboardingModal={openStudentOnboardingCard} setToolTip={setToolTip} />)}
                                </div>
                                :
                                <div className='finished-lady__wrapper'>
                                    <FinishedLady />
                                </div>
                                }
                        </div>
                    }
                    </div>
                )}
            </div>
        </div>
    )
}
export default StudentOnboardingFall2023;